module.exports = "/_next/static/images/associationLogo4-bb441ca2083b429aea8ab05ceea027c0.webp";